import { Button } from '#app/components/Buttons/Button.js';
import { css, styled } from 'styled-components';

export const RatingCategoryLayout = styled.div`
  padding: 16px;
  display: grid;
  gap: 8px;
`;

export const RatingCategoryLabel = styled.span`
  font-size: 14px;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.semiBold};
    color: ${theme.colorsV2.gray80};
  `};
`;

export const RatingCategoryValues = styled.div`
  display: flex;
  margin-top: 2px;
`;

export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  line-height: 0;

  width: 56px;
  justify-content: space-around;
`;

export const StyledButton = styled(Button)`
  margin-top: 16px;
`;

export const RatingGrid = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 16px;
    grid-template-columns: 208px 208px;
    &:first-child {
      margin-bottom: 8px;
      padding-bottom: 16px;
      border-bottom: 1px solid ${theme.colorsV2.gray40};
    }
  `}
`;
